if (!customElements.get('ff-fidrio-film')) {
  customElements.define('ff-fidrio-film', class extends HTMLElement {
    connectedCallback() {
      const link = this.querySelector('a');
      if (!link || this.bound) return;
      this.bound = true;
      link.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const id = this.dataset.videoId;
        if (!/^[\w-]{11}$/.test(id || '')) return;
        event.preventDefault();
        const frame = document.createElement('iframe');
        frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
        frame.title = link.getAttribute('aria-label');
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        this.replaceChildren(frame);
        frame.focus();
      });
    }
  });
}
